import { setSelectedFilter } from "@/redux/actions/filtersAction";
import { useEffect, useState } from "react";
import styles from "./SelectedFilters.module.scss";
import Router from "next/router";
import { removePLPFilterCookies } from "@/helpers/generalHelper";

const SelectedFilters = (props) => {
  const { dispatch, router } = props
  const [select_dataLable, setSelect_dataLable] = useState()

  let pathnameRouter = router.pathname
  if(pathnameRouter === "/[...pages]") {
    pathnameRouter = router.query.pages.join('/')
  }
  const removeAllFilter = () => {
    removePLPFilterCookies(pathnameRouter);
    if(props.brand_name || props.nav_cat || props.nav_type || props.nav_subcat) {
      Router.reload(window.location.pathname)
    } 
    else {
    { props.refine(props.items) }
    props.dispatch(setSelectedFilter({
      'type': '',
      'category': '',
      'subcategory': ''
    }))
  }

  }

 //FOR REMOVE SELECTED PRICE IF RANGE IS SELECTED  START HERE//
useEffect(()=>{
 
  props.items.map((data)=>{
    if(data.attribute == "price"){
      if(data.currentRefinement.min){
     props.items.map((data)=>{
     
          if(data.currentRefinement == "$200 and under" || data.currentRefinement == "$300 and under" || data.currentRefinement == "$500 and under" || data.currentRefinement == "$1000 and under" || data.currentRefinement == "$1000 +"){
          
            props.refine(data.value)
          }
        })


      }
    }
  })
})
//FOR REMOVE SELECTED PRICE IF RANGE IS SELECTED END HERE//

  useEffect(() => {

    if (select_dataLable) {


      if (select_dataLable.attribute === "named_tags.categories.lvl1" || select_dataLable.attribute === "named_tags.categories.lvl2") {
        props.items?.map((data, index) => {
          if (select_dataLable) {

            if (data.attribute === "named_tags.categories.lvl1") {

              props.items?.map((item, i) => {

                item.items?.map((nested, j) => {

                  if (nested.label.includes(select_dataLable.label.split(">").pop())) {
                    props.refine(nested.value)
                    if(nested.label.split(' > ').length === 2)  {
                      let localBrand = decodeURIComponent(sessionStorage.getItem(`${pathnameRouter}~category`)).split(',')
                      let indexOf = localBrand.indexOf(nested.label)
                      let arr = localBrand
                      if(indexOf >= 0) {
                        localBrand.splice(indexOf, 1)
                        arr = [...localBrand]
                      }
                      sessionStorage.setItem(`${pathnameRouter}~category`, arr.join(',').toString())
                    }
                    else if(nested.label.split(' > ').length === 3)  {
                      let localBrand = decodeURIComponent(sessionStorage.getItem(`${pathnameRouter}~subcategory`)).split(',')
                      let indexOf = localBrand.indexOf(nested.label)
                      let arr = localBrand
                      if(indexOf >= 0) {
                        localBrand.splice(indexOf, 1)
                        arr = [...localBrand]
                      }
                      sessionStorage.setItem(`${pathnameRouter}~subcategory`, arr.join(',').toString())
                    }
                    setSelect_dataLable('')
                  }
                })
              })
            }

          }

          data.items?.map((nested, i) => {

            if (select_dataLable) {
              if (select_dataLable.label.includes(">")) {
                var data = select_dataLable.label.split(">").pop()
                if (nested.label.includes(data)) {

                  data?.items?.splice(i, 1);
                  props.items?.splice(index, 1);

                }
              }
              else if (select_dataLable.attribute === "named_tags.categories.lvl0") {

                props.refine(select_dataLable.value)
                setSelect_dataLable("")

              }
              let splitLable = select_dataLable.label.split(' > ')
              if (splitLable.length === 1) {
                dispatch(setSelectedFilter({
                  'type': '',
                  'category': '',
                  'subcategory': ''
                }))
              }
              setSelect_dataLable('')
            }
          })

        })
      }

    }

  })


  useEffect(() => {

    if (select_dataLable) {


      if (select_dataLable.attribute === "named_tags.categories.lvl0") {

        sessionStorage.setItem(`${pathnameRouter}~type`, '')
        sessionStorage.setItem(`${pathnameRouter}~category`, '')
        sessionStorage.setItem(`${pathnameRouter}~subcategory`, '')
        dispatch(setSelectedFilter({
          'type': '',
          'category': '',
          'subcategory':''
        }))
        props.items?.map((data, index) => {
          if (select_dataLable) {

            if (data.attribute === "named_tags.categories.lvl1") {

              props.items?.map((item, i) => {

                item.items?.map((nested, j) => {

                  if (nested.label.includes(select_dataLable.label.split(">").pop())) {

                    props.refine(nested.value)
                    setSelect_dataLable('')

                  }
                })
              })
            }

          }

          data.items?.map((nested, i) => {

            if (select_dataLable) {
              if (select_dataLable.label.includes(">")) {
                var data = select_dataLable.label.split(">").pop()
                if (nested.label.includes(data)) {

                  data?.items?.splice(i, 1);
                  props.items?.splice(index, 1);

                }
              }
              else if (select_dataLable.attribute === "named_tags.categories.lvl0") {
                props.refine(select_dataLable.value)
                // setSelect_dataLable("")

              }
              let splitLable = select_dataLable.label.split(' > ')
              if (splitLable.length === 1) {
                dispatch(setSelectedFilter({
                  'type': '',
                  'category': '',
                  'subcategory': ''
                }))
              }
              setSelect_dataLable('')
            }
          })

        })
      }
    }

  }, [select_dataLable])

  useEffect(() => {
    if (select_dataLable) {
      if (select_dataLable.attribute === "price") {
        if (select_dataLable.label === "price: $200 and under" || select_dataLable.label === "price: $300 and under" || select_dataLable.label === "price: $500 and under" || select_dataLable.label === "price: $1000 and under" || select_dataLable.label === "price: Under $1000+") {
          sessionStorage.setItem(`${pathnameRouter}~Price`, '')
        }
        else {
          sessionStorage.setItem(`${pathnameRouter}~maxPrice`, '')
          sessionStorage.setItem(`${pathnameRouter}~minPrice`, '')
          document.getElementById("myForm").reset();
        }
      } else if( select_dataLable.attribute === 'vendor' ) {
        
        let localBrand =  sessionStorage.getItem(`${pathnameRouter}~Brand`)
        if(localBrand) {
          localBrand = localBrand.split(',')
          let indexOf = localBrand.indexOf(select_dataLable.label)
          let arr = localBrand
          if(indexOf >= 0) {
            localBrand.splice(indexOf, 1)
            arr = localBrand
          }
          sessionStorage.setItem(`${pathnameRouter}~Brand`, arr.join(',').toString())
        }
      } else if( select_dataLable.attribute === 'meta.color.base_color' ){
        let localBrand = sessionStorage.getItem(`${pathnameRouter}~Color`)
        if(localBrand) {
          localBrand = localBrand.split(',')
          let indexOf = localBrand.indexOf(select_dataLable.label)
          let arr = localBrand
          if(indexOf >= 0) {
            localBrand.splice(indexOf, 1)
            arr = localBrand
          }
          sessionStorage.setItem(`${pathnameRouter}~Color`, arr.join(',').toString())
        }
      } else if( select_dataLable.attribute === 'named_tags.Material') {
        let localBrand = sessionStorage.getItem(`${pathnameRouter}~Material`)
        if(localBrand) {
          localBrand = localBrand.split(',')
          let indexOf = localBrand.indexOf(select_dataLable.label)
          let arr = localBrand
          if(indexOf >= 0) {
            localBrand.splice(indexOf, 1)
            arr = localBrand
          }
          sessionStorage.setItem(`${pathnameRouter}~Material`, arr.join(',').toString())
        }
      } else if( select_dataLable.attribute === 'named_tags.Style_Sleeves') {
        let localBrand = sessionStorage.getItem(`${pathnameRouter}~Sleeves`)
        if(localBrand) {
          localBrand = localBrand.split(',')
          let indexOf = localBrand.indexOf(select_dataLable.label)
          let arr = localBrand
          if(indexOf >= 0) {
            localBrand.splice(indexOf, 1)
            arr = localBrand
          }
          sessionStorage.setItem(`${pathnameRouter}~Sleeves`, arr.join(',').toString())
        }
      } else if( select_dataLable.attribute === 'named_tags.Style_Heel_Height') {
        let localBrand = sessionStorage.getItem(`${pathnameRouter}~Heel Height`)
        if(localBrand) {
          localBrand = localBrand.split(',')
          let indexOf = localBrand.indexOf(select_dataLable.label)
          let arr = localBrand
          if(indexOf >= 0) {
            localBrand.splice(indexOf, 1)
            arr = localBrand
          }
          sessionStorage.setItem(`${pathnameRouter}~Heel Height`, arr.join(',').toString())
        }
      } else if( select_dataLable.attribute === 'named_tags.Occasion') {
        let localBrand = sessionStorage.getItem(`${pathnameRouter}~Occasion`)
        if(localBrand) {
          localBrand = localBrand.split(',')
          let indexOf = localBrand.indexOf(select_dataLable.label)
          let arr = localBrand
          if(indexOf >= 0) {
            localBrand.splice(indexOf, 1)
            arr = localBrand
          }
          sessionStorage.setItem(`${pathnameRouter}~Occasion`, arr.join(',').toString())
        }
      } 
      props.refine(select_dataLable.value)
      
      setSelect_dataLable('') 
    }
  }, [select_dataLable])

  useEffect(() => {
    /**
     * Set redux after @select_dataLabele chnage
     * Read data from @sessionStorage to upDate redux
     */
    if(select_dataLable) {

      let filteredObject = {}
      
      filteredObject['type'] = sessionStorage.getItem(`${pathnameRouter}~type`) || ''
      if(props.nav_type) {
        filteredObject['type'] = props.nav_type
      }
      let cat = sessionStorage.getItem(`${pathnameRouter}~category`) || ''
      cat = cat?.split(',')
      cat.forEach((value, index) => {
        cat[index] = value.split(' > ').pop()
      })
      filteredObject['category'] = cat.join(',')
      filteredObject['category'] = filteredObject['category'] || ''

      let subcat = sessionStorage.getItem(`${pathnameRouter}~subcategory`) || ''
      subcat = subcat?.split(',')
      subcat.forEach((value, index) => {
        subcat[index] = value.split(' > ').pop()
      })
      filteredObject['subcategory'] = subcat.join(',')
      filteredObject['subcategory'] = filteredObject['subcategory'] || ''
      dispatch(setSelectedFilter({ ...filteredObject }))      
    }
  }, [select_dataLable])

  if (props.selected > 0)
    return (
      <div className={`${styles.filter_view}`}>
        <div className={`${styles.filter_total}`}>
          <span className="x-small-sm x-small-md xx-small-xs">{props.selected}</span>
          <div className={`${styles.filter_remove}`} onClick={() => removeAllFilter()}><img src={`${process.env.NETLIFY_URL}/icons/Cross/Large-sm.svg`} alt="filter remove" /></div>
        </div>
        {
          props.items?.map((item) => {
            if (item.attribute === "price") {
              if(item.label.indexOf('<= price <=') != -1){
                item.label = '$'+item.label.replace("<= price <= ", "- $");
              }
              else if(item.label.indexOf('<= price') != -1){
                item.label = '$'+item.label.replace("<= price", "and Above");
              }
              return <div className={`${styles.filter_item}`} key={item.label}>
                <div className={`${styles.select_filter} small`}>{item.label.replace("price: ", "")}</div>
                <div className={`${styles.filter_remove}`} onClick={() => { setSelect_dataLable({ label: item.label, value: item.value, attribute: item.attribute }) }}><img src={`${process.env.NETLIFY_URL}/icons/Cross/Large-sm.svg`} alt="filter remove" /></div>
              </div>
            }
            
            return item.items?.map((nested) => {
//#############
              let del = false;
              let val_selected = nested.label.split('>').pop().trim()
              if(val_selected === props.brand_name || val_selected === props.nav_type || val_selected === props.nav_cat || val_selected === props.nav_subcat) {
                del = true;
              }
              if(del) {
                return '';
              } 
              return <div className={`${styles.filter_item}`} key={nested.label}>
                <div className={`${styles.select_filter} small`}>{val_selected}</div>
                <div className={`${styles.filter_remove}`} onClick={() => { 
                  setSelect_dataLable({ label: nested.label, value: nested.value, attribute: item.attribute }) 
                  }}><img src={`${process.env.NETLIFY_URL}/icons/Cross/Large-sm.svg`} alt="filter remove" /></div>
              </div>
            }
            )
          }

          )
        }
      </div>
    )
}

export default SelectedFilters